import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { USE_CASE_LINKS } from "../content/useCases";

const LINKS = [
  { to: "/pricing", label: "PRICING", testid: "nav-pricing" },
  { to: "/help/camera", label: "CAMERA HELP", testid: "nav-camera-help" },
  { to: "/contact", label: "CONTACT", testid: "nav-contact" },
  { to: "/login", label: "SIGN IN", testid: "nav-signin" },
];

// Public marketing chrome (landing / pricing / contact) — rendered OUTSIDE Shell.
export function MarketingFrame({ children, testid, title, description, jsonLd }) {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) { m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); }
      m.content = description;
    }
    let canon = document.querySelector('link[rel="canonical"]');
    if (!canon) { canon = document.createElement("link"); canon.rel = "canonical"; document.head.appendChild(canon); }
    canon.href = `https://aiimagesuites.pro${pathname}`;
  }, [title, description, pathname]);
  return (
    <div className="min-h-[100dvh] bg-white text-black flex flex-col overflow-x-hidden" data-testid={testid}>
      {jsonLd && (
        <script type="application/ld+json" data-testid="jsonld" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      )}
      <header className="border-b-2 border-black px-4 sm:px-6 py-3 sm:py-4 flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
        <Link to="/" className="font-display font-black tracking-tighter text-xl sm:text-2xl" data-testid="nav-brand">
          AIIMAGESUITES
        </Link>
        <nav className="flex flex-wrap items-center gap-x-3 sm:gap-x-6 gap-y-1 label-mono text-[10px] sm:text-xs text-neutral-600">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} data-testid={l.testid} className="hover:text-black hover:underline underline-offset-4">
              {l.label}
            </Link>
          ))}
        </nav>
      </header>
      <main className="flex-1">{children}</main>
      <footer className="border-t-2 border-black px-6 py-4 space-y-2">
        <div className="label-mono text-neutral-500 flex flex-wrap gap-x-4 gap-y-1" data-testid="footer-usecases">
          <span className="text-neutral-400">BUILT FOR</span>
          {USE_CASE_LINKS.map((l) => <Link key={l.to} to={l.to} className="hover:text-black">{l.label}</Link>)}
        </div>
        <div className="flex flex-col sm:flex-row gap-2 sm:items-center justify-between">
        <span className="label-mono text-neutral-500">v1.0 · BUILT FOR HIGH-VOLUME CAPTURE</span>
        <span className="label-mono text-neutral-500 flex flex-wrap gap-4">
          <Link to="/pricing" className="hover:text-black">PRICING</Link>
          <Link to="/compare/capture-time-naming-vs-renaming" className="hover:text-black" data-testid="footer-compare">VS. RENAMERS</Link>
          <Link to="/enterprise" className="hover:text-black" data-testid="footer-enterprise">ENTERPRISE</Link>
          <Link to="/help/camera" className="hover:text-black">CAMERA HELP</Link>
          <Link to="/contact" className="hover:text-black">CONTACT</Link>
          <a href="https://aiimagesuite.pro" target="_blank" rel="noreferrer" className="hover:text-black">AIIMAGESUITE.PRO ↗</a>
        </span>
        </div>
      </footer>
    </div>
  );
}
